import React, { Component } from "react";
import PageTitle from "../../../commons/components/PageTitle";
import { ButtonArea, InfoArea, InfoContent, InfoHead } from "../PlantListStyle";
import CountUp from "react-countup";

import MS from "../../../commons/services/Moment";
import AS from "../../Login/Service/Authentication";
import PS from "./../MonitoringApiService";
import CS from "../../../commons/services/Common";
import axios from "axios";
import Divider from "../../../commons/components/divider/Divider";
import styled from "styled-components";
import StatusButton from "../../../commons/components/button/StatusButton";
import { Message } from "element-react";
import { BatteryDataRes } from "./dto/BatteryDataRes";
import MakeKey from "../../../commons/services/MakeKey";
import { ROUTES } from "../../../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";
import AutoFitText from "../../../commons/components/text/AutoFitText"


class BatteryDetail extends Component {
  constructor(props) {
    super(props);
    const { state } = this.props.location;
    this.state = {
      plantId: null,
      projectId: props.location.state?.projectId || "",
      projectName: "",
      projectAddr: "",
      info: {
      },
      battery: {
        ...state.battery
      },
      batteryInfo: { // 배터리 모니터링 상세정보id: "",
        deviceCompany: "",
        serialNo: "",
        siteNo: 0,
        rtuId: "",
        deviceNo: 0,
        state: 0,
        systemAuto: 0,
        systemManual: 0,
        chargeOn: 0,
        dischargeOn: 0,
        s1SaltNaclLv: 0,
        b1BaseNaohLv: 0,
        a1AcidHclLv: 0,
        e1ElecNa2so4Lv: 0,
        s2SaltNaclLv: 0,
        b2BaseNaohLv: 0,
        a2AcidHclLv: 0,
        d1DrainLv: 0,
        s1SaltNaclPh: 0,
        b1BaseNaohPh: 0,
        a1AcidHclPh: 0,
        e1ElecNa2so4Ph: 0,
        s2SaphNaclPh: 0,
        b2BaseNaohPh: 0,
        a2AcidHclPh: 0,
        s1SaltNaclCond: 0,
        b1BaseNaohCond: 0,
        a1AcidHclCond: 0,
        e1ElecNa2so4Cond: 0,
        s2SaltNaclCond: 0,
        b2BaseNaohCond: 0,
        a2AcidHclCond: 0,
        s11SaltNaclChargeFlow: 0,
        b11BaseNaohChargeFlow: 0,
        a11AcidHclChargeFlow: 0,
        e1ElecNa2so4ChargeFlow: 0,
        s21SaftNaclChargeFlow: 0,
        b21BaseNaohChargeFlow: 0,
        a21AcidHclChargeFlow: 0,
        s12SaltNaclDischargeFlow: 0,
        b12BaseNaohDischargeFlow: 0,
        a12AcidHclDischargeFlow: 0,
        e1ElecNa2so4DischargeFlow: 0,
        s22SaftNaclDischargeFlow: 0,
        b22BaseNaohDischargeFlow: 0,
        a22AcidHclDischargeFlow: 0,
        s11SaltNaclChargePressure: 0,
        b11BaseNaohChargePressure: 0,
        a11AcidHclChargePressure: 0,
        e1ElecNa2so4ChargePressure: 0,
        s21SaptNaclChargePressure: 0,
        b21BaseNaohChargePressure: 0,
        a21AcidHclChargePressure: 0,
        s12SaltNaclDischargePressure: 0,
        b12BaseNaohDischargePressure: 0,
        a12AcidHclDischargePressure: 0,
        e1ElecNa2so4DischargePressure: 0,
        s22SaptNaclDischargePressure: 0,
        b22BaseNaohDischargePressure: 0,
        a22AcidHclDischargePressure: 0,
        panelInputValtage: 0,
        panelInputAmprere: 0,
        panelPower: 0,
        panelWattage: 0,
        ed1ChargeVoltage: 0,
        ed1ChargeAmprere: 0,
        ed1ChargeWattage: 0,
        ed2DischargeVoltage: 0,
        ed2DischargeAmprere: 0,
        ed2DischargeWattage: 0,
        ed1ChargeAccPower: 0,
        ed2DischargeAccPower: 0,
      },
      inverterSerialNos: [],

      accumulationPower: 0,
    }
  }

  componentDidMount() {
    this.getProjectInfo();
    // this.getPlantInfo();
    this.fetchBatteryDetailData();
  }

  // 배터리 세부 정보 mongoDB 데이터
  async fetchBatteryDetailData() {
    const { t } = this.props;
    const { battery } = this.state;
    const batteryKey = MakeKey.battery({
      siteNo: battery.siteNo,
      rtuNo: battery.rtuNo,
      deviceNo: battery.deviceNo
    });
    const { typeId } = battery;
    try {
      const batteryDataList = await PS.getBatteryDetail([batteryKey]);
      if (batteryDataList.length === 1) {
        console.log("배터리 상세 데이터:", batteryDataList[0]);
        const resBattery = new BatteryDataRes(batteryDataList[0]);
        // resBattery.setTestInfo(); // 테스트용 데이터 적용
        this.setState({
          batteryInfo: resBattery.toObject()
        })
        return;
      }
      if (typeId !== 2) {
        Message({
          type: "info",
          message: t('key642'), // 배터리 정보를 불러오기를 실패하였습니다.
          iconClass: "cancel",
        });
      }
    } catch (error) {
      console.error("배터리 정보 불러오기 실패", error);
      if (typeId !== 2) {
        Message({
          type: "info",
          message: t('key642'), // 배터리 정보를 불러오기를 실패하였습니다.
          iconClass: "cancel",
        });
      }
      
    }
  }

  async getProjectInfo() {
    const result = await axios.get(
      `/cst/api/project/id/` + this.state.projectId
    );
    this.setState({
      projectName: result.data.name,
      projectAddr: result.data.address,
    });
  }

  async getPlantInfo() {
    const { plantId, inverterSerialNos } = this.state;
    if (inverterSerialNos.length == 0) {
      const res = await axios.get(
        `/usr/api/user-plant/info?plantIds=${this.state.plantId}`
      );
      this.setState({
        info: res.data[0],
      });
      const plantInfos = AS.getLoggedInPlantInfos();
      let filteredPlantInfo = plantInfos.filter((v) => v.id == plantId);
      let inverterSerialNos = [];
      let combinerSerialNos = [];
      if (filteredPlantInfo[0]) {
        inverterSerialNos = CS.getKeyValues(
          filteredPlantInfo[0].invs,
          "serialNo"
        );
        combinerSerialNos = CS.getKeyValues(
          filteredPlantInfo[0].invs,
          "combinerSerialNo"
        );
      }

      this.setState({
        inverterSerialNos: inverterSerialNos,
        combinerSerialNos: combinerSerialNos,
        plantInfo: filteredPlantInfo,
      });
    }

  }
  
  formatSize(size) {
    if (size > 1000) {
      return size / 1000;
    }
    return size;
  }

  formatUnit(size) {
    if (size > 1000) {
      return "MWh";
    }
    return "kWh";
  }

  render() {
    const {
      info,
      accumulationPower,
      batteryInfo,
      projectName,
      projectId,
      battery
    } = this.state;

    const batteryKey = MakeKey.battery({ siteNo: batteryInfo.siteNo, rtuNo: batteryInfo.rtuId, deviceNo: batteryInfo.deviceNo });
    const { t } = this.props;
    const { typeId } = battery;
    return (
      <>
        <PageTitle title={t('key47')} location={t('key309')} />
        {
          typeId === 2 ? (
            <iframe 
              title="external-monitoring"
              src={battery.externalUrl}
              width="100%"
              height={"1000px"}
              style={{ border: "none", marginBottom: "30px", width: "1176px", margin: "0 auto", display: "block" }}
            />
          ) : (
            <InfoArea>
              <InfoHead>
                <h1>{battery.name}</h1>
                <ButtonArea>
                  <a
                    onClick={() =>
                      window.open(
                        ROUTES.PLANT_LIST(projectId).BATTERY_GRAPH(batteryKey),
                        "_blank"
                      )
                    }
                  >
                    {t('key310')}
                  </a>
                </ButtonArea>
              </InfoHead>
              <InfoContent>
                <dl>
                  <dt>{t('key311')}</dt>
                  <dd> {this.state.projectName} </dd>
                </dl>
                <dl>
                  <dt>{t('key312')}</dt>
                  <dd> {this.state.projectAddr} </dd>
                </dl>
                <dl className="total-unit">
                  <dt>{t('key313')}</dt>
                  <dd>{battery.capacity} kW</dd>
                </dl>
              </InfoContent>
              <Divider /> 
              <BatteryInfo 
                systemAuto={batteryInfo.systemAuto}
                systemManual={batteryInfo.systemManual}
                chargeOn={batteryInfo.chargeOn}
                dischargeOn={batteryInfo.dischargeOn}
                state={batteryInfo.state}
                time={batteryInfo?.time || ""}
                t={t}
              />
              <Divider /> 
              <TankLevel 
                level={{        
                  s1SaltNaclLv: batteryInfo.s1SaltNaclLv,
                  b1BaseNaohLv: batteryInfo.b1BaseNaohLv,
                  a1AcidHclLv: batteryInfo.a1AcidHclLv,
                  e1ElecNa2so4Lv: batteryInfo.e1ElecNa2so4Lv,
                  s2SaltNaclLv: batteryInfo.s2SaltNaclLv,
                  b2BaseNaohLv: batteryInfo.b2BaseNaohLv,
                  a2AcidHclLv: batteryInfo.a2AcidHclLv,
                  d1DrainLv: batteryInfo.d1DrainLv,
                }}
                t={t}
              />
              <Divider />
              <TankPh
                ph={{
                  s1SaltNaclPh: batteryInfo.s1SaltNaclPh,
                  b1BaseNaohPh: batteryInfo.b1BaseNaohPh,
                  a1AcidHclPh: batteryInfo.a1AcidHclPh,
                  e1ElecNa2so4Ph: batteryInfo.e1ElecNa2so4Ph,
                  s2SaltNaclPh: batteryInfo.s2SaphNaclPh,
                  b2BaseNaohPh: batteryInfo.b2BaseNaohPh,
                  a2AcidHclPh: batteryInfo.a2AcidHclPh,
                }}
                t={t}
              />
              <Divider />
              <TankConductivity
                cond={{
                  s1SaltNaclCond: batteryInfo.s1SaltNaclCond,
                  b1BaseNaohCond: batteryInfo.b1BaseNaohCond,
                  a1AcidHclCond: batteryInfo.a1AcidHclCond,
                  e1ElecNa2so4Cond: batteryInfo.e1ElecNa2so4Cond,
                  s2SaltNaclCond: batteryInfo.s2SaltNaclCond,
                  b2BaseNaohCond: batteryInfo.b2BaseNaohCond,
                  a2AcidHclCond: batteryInfo.a2AcidHclCond,
                }}
                t={t}
              />  
              <Divider />
              <ModeFlow
                flow={{
                  s11SaltNaclChargeFlow: batteryInfo.s11SaltNaclChargeFlow,
                  b11BaseNaohChargeFlow: batteryInfo.b11BaseNaohChargeFlow,
                  a11AcidHclChargeFlow: batteryInfo.a11AcidHclChargeFlow,
                  e1ElecNa2so4ChargeFlow: batteryInfo.e1ElecNa2so4ChargeFlow,
                  s21SaftNaclChargeFlow: batteryInfo.s21SaftNaclChargeFlow,
                  b21BaseNaohChargeFlow: batteryInfo.b21BaseNaohChargeFlow,
                  a21AcidHclChargeFlow: batteryInfo.a21AcidHclChargeFlow,
                  s12SaltNaclDischargeFlow: batteryInfo.s12SaltNaclDischargeFlow,
                  b12BaseNaohDischargeFlow: batteryInfo.b12BaseNaohDischargeFlow,
                  a12AcidHclDischargeFlow: batteryInfo.a12AcidHclDischargeFlow,
                  e1ElecNa2so4DischargeFlow: batteryInfo.e1ElecNa2so4DischargeFlow,
                  s22SaftNaclDischargeFlow: batteryInfo.s22SaftNaclDischargeFlow,
                  b22BaseNaohDischargeFlow: batteryInfo.b22BaseNaohDischargeFlow,
                  a22AcidHclDischargeFlow: batteryInfo.a22AcidHclDischargeFlow,
                }}
                t={t}
              />
              <Divider /> 
              <ModePressure 
                pressure={{
                  s11SaltNaclChargePressure: batteryInfo.s11SaltNaclChargePressure,
                  b11BaseNaohChargePressure: batteryInfo.b11BaseNaohChargePressure,
                  a11AcidHclChargePressure: batteryInfo.a11AcidHclChargePressure,
                  e1ElecNa2so4ChargePressure: batteryInfo.e1ElecNa2so4ChargePressure,
                  s21SaltNaclChargePressure: batteryInfo.s21SaptNaclChargePressure,
                  b21BaseNaohChargePressure: batteryInfo.b21BaseNaohChargePressure,
                  a21AcidHclChargePressure: batteryInfo.a21AcidHclChargePressure,
                  s12SaltNaclDischargePressure: batteryInfo.s12SaltNaclDischargePressure,
                  b12BaseNaohDischargePressure: batteryInfo.b12BaseNaohDischargePressure,
                  a12AcidHclDischargePressure: batteryInfo.a12AcidHclDischargePressure,
                  e1ElecNa2so4DischargePressure: batteryInfo.e1ElecNa2so4DischargePressure,
                  s22SaltNaclDischargePressure: batteryInfo.s22SaptNaclDischargePressure,
                  b22BaseNaohDischargePressure: batteryInfo.b22BaseNaohDischargePressure,
                  a22AcidHclDischargePressure: batteryInfo.a22AcidHclDischargePressure,
                }}
                t={t}
              />
              <Divider />
              <PandelEd
                panelEd={{
                  panelInputValtage: batteryInfo.panelInputValtage,
                  panelInputAmprere: batteryInfo.panelInputAmprere,
                  panelPower: batteryInfo.panelPower,
                  panelWattage: batteryInfo.panelWattage,
                  ed1ChargeVoltage: batteryInfo.ed1ChargeVoltage,
                  ed1ChargeAmprere: batteryInfo.ed1ChargeAmprere,
                  ed1ChargeWattage: batteryInfo.ed1ChargeWattage,
                  ed1ChargeAccPower: batteryInfo.ed1ChargeAccPower,
                  ed2DischargeVoltage: batteryInfo.ed2DischargeVoltage,
                  ed2DischargeAmprere: batteryInfo.ed2DischargeAmprere,
                  ed2DischargeWattage: batteryInfo.ed2DischargeWattage,
                  ed2DischargeAccPower: batteryInfo.ed2DischargeAccPower,
                }}
                t={t}
              />
            </InfoArea>
          )
        }
      </>
    )
  }
}

class BatteryInfoCard extends Component {
  render() {
    const { title, value, unit, decimals = 0 } = this.props;
    return (
      <InfoCardContainer>
        <InfoCardTitle>
          <AutoFitText max={15} min={4}>
            {title}
          </AutoFitText>
        </InfoCardTitle>
        <UnitAndValueContainer>
          <div className="left-value">
            {
              value === null ? (
                <div>
                  --
                </div>
              ) : (
                <CountUp 
                  start={0}
                  end={Number(value)}
                  decimals={decimals || 0}
                  duration={3.5}
                  separator=","
                />
              )
            }
          </div>
          <div className="right-unit">
            {unit}
          </div>
        </UnitAndValueContainer>
      </InfoCardContainer>
    )
  }
}

const InfoCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  min-height: 88px;
  background-color: #F2F3F5;
  border-radius: 12px;
  border: 1px solid #E5E6E8;
  padding: 15px 20px;
`;
const InfoCardTitle = styled.div`
  height: 25px;
  line-height: 25px;
  font-size: 15px;
  font-weight: 500;
`;
const UnitAndValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 28px;
  line-height: 28px;

  & .left-value {
    font-size: 22px;
    font-weight: 600;
  }

  & .right-unit {
    font-size: 18px;
    font-weight: 500;
  }
`;

class BatteryInfo extends Component {
  render() {
    const {
      systemAuto,
      systemManual,
      chargeOn,
      dischargeOn,
      state,
      time,
      t
    } = this.props;

    return (
      <SectionContainer>
        <SectionTitle>
          <span>
            {t('key314')}
          </span>
          <span className="time">
            {time || ""}
          </span>
        </SectionTitle>
        <GridContainer gridFr={"3"}>
          <BatteryInfoCard 
            title="SYSTEM MODE" 
            value={null} 
            unit={
              <StatusButton type={systemAuto ? "on" : "error"}>
                {systemAuto ? "AUTO" : "MANUAL"}
              </StatusButton>
            } 
          />
          {/* <BatteryInfoCard 
            title="SYSTEM MANUAL" 
            value={null} 
            unit={
              <StatusButton type={systemManual ? "on" : "error"}>
                {systemManual ? "ON" : "OFF"}
              </StatusButton>
            } 
          /> */}
          <BatteryInfoCard 
            title={t('key318')}
            value={null} 
            unit={
              <StatusButton type={chargeOn ? "on" : "error"}>
                {chargeOn ? t('key319') : t('key320')}
              </StatusButton>
            } 
          />
          {/* <BatteryInfoCard 
            title="방전모드 ON" 
            value={null} 
            unit={
              <StatusButton type={dischargeOn ? "on" : "error"}>
                {dischargeOn ? "ON" : "OFF"}
              </StatusButton>
            } 
          /> */}
          <BatteryInfoCard 
            title={t('key321')}
            value={null} 
            unit={
              <StatusButton type={state ? "on" : "error"}>
                {state ? t('key322') : t('key323')}
              </StatusButton>
            } 
          />
        </GridContainer>
      </SectionContainer>
    )
  }
}


class TankLevel extends Component {
  render() {
    const { level, t } = this.props; // level은 props로 전달됨
    return (
      <SectionContainer>
        <SectionTitle>TANK LEVEL (0~100%)</SectionTitle>
        <GridContainer>
          <BatteryInfoCard title={t('key643')} value={level.s1SaltNaclLv} unit="%" />
          <BatteryInfoCard title={t('key644')} value={level.b1BaseNaohLv} unit="%" />
          <BatteryInfoCard title={t('key645')} value={level.a1AcidHclLv} unit="%" />
          <BatteryInfoCard title={t('key646')} value={level.e1ElecNa2so4Lv} unit="%" />
          <BatteryInfoCard title={t('key647')} value={level.s2SaltNaclLv} unit="%" />
          <BatteryInfoCard title={t('key648')} value={level.b2BaseNaohLv} unit="%" />
          <BatteryInfoCard title={t('key649')} value={level.a2AcidHclLv} unit="%" />
          <BatteryInfoCard title={t('key650')} value={level.d1DrainLv} unit="%" />
        </GridContainer>
      </SectionContainer>
    );
  }
}

class TankPh extends Component {
  render() {
    const { ph, t } = this.props;
    return (
      <SectionContainer>
        <SectionTitle>{t('key658')}</SectionTitle> {/* TANK PH (0.0~14.0PH) */}
        <GridContainer>
          <BatteryInfoCard title={t('key651')} value={ph.s1SaltNaclPh} unit="PH" decimals={1} />
          <BatteryInfoCard title={t('key652')} value={ph.b1BaseNaohPh} unit="PH" decimals={1} />
          <BatteryInfoCard title={t('key653')} value={ph.a1AcidHclPh} unit="PH" decimals={1} />
          <BatteryInfoCard title={t('key654')} value={ph.e1ElecNa2so4Ph} unit="PH" decimals={1} />
          <BatteryInfoCard title={t('key655')} value={ph.s2SaltNaclPh} unit="PH" decimals={1} />
          <BatteryInfoCard title={t('key656')} value={ph.b2BaseNaohPh} unit="PH" decimals={1} />
          <BatteryInfoCard title={t('key657')} value={ph.a2AcidHclPh} unit="PH" decimals={1} />
        </GridContainer>
      </SectionContainer>
    );
  }
}

class TankConductivity extends Component {
  render() {
    const { cond, t } = this.props;
    return (
      <SectionContainer>
        <SectionTitle>{t('key659')}</SectionTitle> {/* TANK CONDUCTIVITY (0.0~500.0 ms) */}
        <GridContainer>
          <BatteryInfoCard title="S-1 Salt NaCl" value={cond.s1SaltNaclCond} unit="ms" decimals={1} />
          <BatteryInfoCard title="B-1 Base NaOH" value={cond.b1BaseNaohCond} unit="ms" decimals={1} />
          <BatteryInfoCard title="A-1 Acid HCl" value={cond.a1AcidHclCond} unit="ms" decimals={1} />
          <BatteryInfoCard title="E-1 Electrolyte Na2SO4" value={cond.e1ElecNa2so4Cond} unit="ms" decimals={1} />
          <BatteryInfoCard title="S-2 Salt NaCl" value={cond.s2SaltNaclCond} unit="ms" decimals={1} />
          <BatteryInfoCard title="B-2 Base NaOH" value={cond.b2BaseNaohCond} unit="ms" decimals={1} />
          <BatteryInfoCard title="A-2 Acid HCl" value={cond.a2AcidHclCond} unit="ms" decimals={1} />
        </GridContainer>
      </SectionContainer>
    );
  }
}

class ModeFlow extends Component {
  render() {
    const { flow, t } = this.props;
    return (
      <SectionContainer>
        <SectionTitle>{t('key324')}</SectionTitle>
        <GridContainer>
          <BatteryInfoCard title={t('key325')} value={flow.s11SaltNaclChargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key326')} value={flow.b11BaseNaohChargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key327')} value={flow.a11AcidHclChargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key328')} value={flow.e1ElecNa2so4ChargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key329')} value={flow.s21SaftNaclChargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key330')} value={flow.b21BaseNaohChargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key331')} value={flow.a21AcidHclChargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key332')} value={flow.s12SaltNaclDischargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key333')} value={flow.b12BaseNaohDischargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key334')} value={flow.a12AcidHclDischargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key335')} value={flow.e1ElecNa2so4DischargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key336')} value={flow.s22SaftNaclDischargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key337')} value={flow.b22BaseNaohDischargeFlow} unit="LPM" decimals={1} />
          <BatteryInfoCard title={t('key338')} value={flow.a22AcidHclDischargeFlow} unit="LPM" decimals={1} />
        </GridContainer>
      </SectionContainer>
    );
  }
}

class ModePressure extends Component {
  render() {
    const { pressure, t } = this.props;
    return (
      <SectionContainer>
        <SectionTitle>{t('key339')}</SectionTitle>
        <GridContainer>
          <BatteryInfoCard title={t('key340')} value={pressure.s11SaltNaclChargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key341')} value={pressure.b11BaseNaohChargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key342')} value={pressure.a11AcidHclChargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key343')} value={pressure.e1ElecNa2so4ChargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key344')} value={pressure.s21SaltNaclChargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key345')} value={pressure.b21BaseNaohChargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key346')} value={pressure.a21AcidHclChargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key347')} value={pressure.s12SaltNaclDischargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key348')} value={pressure.b12BaseNaohDischargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key349')} value={pressure.a12AcidHclDischargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key350')} value={pressure.e1ElecNa2so4DischargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key351')} value={pressure.s22SaltNaclDischargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key352')} value={pressure.b22BaseNaohDischargePressure} unit="bar" decimals={1} />
          <BatteryInfoCard title={t('key353')} value={pressure.a22AcidHclDischargePressure} unit="bar" decimals={1} />
        </GridContainer>
      </SectionContainer>
    );
  }
}


class PandelEd extends Component {
  render() {
    const { panelEd, t } = this.props;
    return (
      <SectionContainer>
        <SectionTitle>PANEL, ED (0.0~000.0)</SectionTitle>
        <GridContainer>
          <BatteryInfoCard title="PANEL INPUT VOLTAGE" value={panelEd.panelInputValtage} unit="V" decimals={1} />
          <BatteryInfoCard title="PANEL INPUT AMPERE" value={panelEd.panelInputAmprere} unit="A" decimals={1} />
          <BatteryInfoCard title={t('key354')} value={panelEd.panelPower} unit="kW" decimals={1} />
          <BatteryInfoCard title={t('key355')} value={panelEd.panelWattage} unit="kWh" decimals={1} /> {/* PANEL WATTAGE 누적 번역 필요 */}
          <BatteryInfoCard title={t('key356')} value={panelEd.ed1ChargeVoltage} unit="V" decimals={1} />
          <BatteryInfoCard title={t('key357')} value={panelEd.ed1ChargeAmprere} unit="A" decimals={1} />
          <BatteryInfoCard title={t('key357A')} value={panelEd.ed1ChargeWattage} unit="W" decimals={1} />
          <BatteryInfoCard title={t('key357B')} value={panelEd.ed1ChargeAccPower} unit="kWh" decimals={1} />
          <BatteryInfoCard title={t('key358')} value={panelEd.ed2DischargeVoltage} unit="V" decimals={1} />
          <BatteryInfoCard title={t('key359')} value={panelEd.ed2DischargeAmprere} unit="A" decimals={1} />
          <BatteryInfoCard title={t('key360')} value={panelEd.ed2DischargeWattage} unit="W" decimals={1} />
          <BatteryInfoCard title={t('key360A')} value={panelEd.ed2DischargeAccPower} unit="kWh" decimals={1} />
        </GridContainer>
      </SectionContainer>
    );
  }
}

// common style 
const SectionContainer = styled.div`
  width: 100%;
  margin: 30px 0;
`;
const SectionTitle = styled.h3`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 28px;
  line-height: 28px;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;

  .time {
    font-size: 14px;
    font-weight: 400;
    color: #999;
    margin-right: 10px;
  }
`;
const GridContainer = styled.div`
  display: grid;
  width: 100%;
  min-width: 100%;
  grid-template-columns: repeat(${({ gridFr }) => gridFr || 4 }, 1fr);
  gap: 20px;
`;

export default withTranslation()(BatteryDetail);